import { customerExperiencesNavigationResource } from '@jira/router-resources__customer-experiences-navigation/src/customerExperiencesNavigationResource.tsx';
import { MenuIdCustomerExperiences } from '@jira/navigation-apps__constants/src/MenuIdCustomerExperiences.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { helpCenterSettingsBrandingRoute } from '@jira/router-routes__help-center-settings-routes/src/helpCenterSettingsBrandingRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { helpCenterSettingBrandingAppPageEntryPoint } from './ui/branding/index.tsx';

export const helpCenterSettingsBrandingRouteEntry: Route = createEntry(
	helpCenterSettingsBrandingRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'help-center-settings.branding',
		layout: serviceProjectLayout,
		navigation: {
			menuId: MenuIdCustomerExperiences,
		},
		// eslint-disable-next-line no-restricted-syntax
		component: ErrorPagesNotFound,
		entryPoint() {
			if (fg('jcs-global-branding')) {
				return helpCenterSettingBrandingAppPageEntryPoint;
			}
			return undefined;
		},
		resources: [...getServiceDeskSettingsResources(), customerExperiencesNavigationResource],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
